import { useTranslate } from "react-admin";

const CustomTitle = (props) => {
    const translate = useTranslate();
    const value = props.value || "name";
    let recordValue = '';
    if (props.record) {
        if (value instanceof Function) {
            recordValue = value(props.record);
        } else {
            recordValue = props.record[value];
        }
    } else {
        recordValue = '';
    }
    const titleDefaultKey = `resources.${props.title}.name`;
    let title = translate(titleDefaultKey, { smart_count: 1 });
    if (title === titleDefaultKey) {
        title = translate(props.title, { smart_count: 1 });
    }
    return (
        <span>
            {translate("resources.editTitle")} {title} : {recordValue}
        </span>
    );
};

export default CustomTitle;